import { Box, Input, Label, ValidationMessage } from '@modusign/design-system';

interface TemplateTitleInputCardProps {
  handleTitleChange: (value: string) => void;
  error: string;
  title: string;
}

function TemplateTitleInputCard({ error, title, handleTitleChange }: TemplateTitleInputCardProps) {
  return (
    <Box className="Card Card--theme-editor Card--primary box-2x">
      <Box className="Card Card--theme-editor" p={6}>
        <Box flex="auto" sx={{ position: 'relative' }}>
          <Label fontSize={2} htmlFor="templateName" mb={4}>
            템플릿 이름
          </Label>
          <Input
            id="templateName"
            isInvalid={!!error}
            maxLength={101}
            placeholder="2자 이상 100자 이하로 입력해주세요."
            value={title}
            onChange={(event) => {
              handleTitleChange(event.target.value);
            }}
          />
          {error && <ValidationMessage>{error}</ValidationMessage>}
        </Box>
      </Box>
    </Box>
  );
}

export default TemplateTitleInputCard;
